/**
 * The Wi-Fi rule for the model download (ADR 0040 amendment): the owner always agrees first, and a download is
 * never started or resumed by itself on mobile data. Browsers say little: Chrome on Android reports the connection's
 * type and the data saver; Safari (every iPhone browser) reports nothing, so there the app asks.
 */
export const Network = {
    /** Wi-Fi or a cable: a download may resume by itself. */
    unmetered: "unmetered",
    /** Mobile data, or the owner asked to save data: never by itself, and the offer says it uses mobile data. */
    metered: "metered",
    /** The browser does not say: ask before resuming, and say it is best on Wi-Fi. */
    unknown: "unknown",
};
/** `NetworkInformation.type` values that cost nothing per byte, and the ones that do. */
const UNMETERED_TYPES = new Set(["wifi", "ethernet"]);
const METERED_TYPES = new Set(["cellular", "wimax", "bluetooth"]);
export function networkOf(connection) {
    if (!connection)
        return Network.unknown;
    if (connection.saveData)
        return Network.metered;
    if (connection.type && METERED_TYPES.has(connection.type))
        return Network.metered;
    if (connection.type && UNMETERED_TYPES.has(connection.type))
        return Network.unmetered;
    return Network.unknown;
}
/** A download the owner agreed to and that stopped part-way may carry on without a tap only on Wi-Fi. */
export const mayResumeAlone = (network) => network === Network.unmetered;
//# sourceMappingURL=network.js.map